<template>
  <div>
    <form class="formfield-round-border" :action="content.form.submit.href" method="get" ref="formSearch">
      <div class="row position-relative margin-lr--20 dmargin-lr-0" dir="rtl">
        <SectionImageComponent :image="$responsive(content.background_images)" clazz="no-radius" />
        <div class="d-flex flex-row search-component-content-area">
          <div class="align-self-center w-100">
            <div class="f30-l30-b df60-l32-b cff text-center">{{content.title}}</div>
            <div class="f26-l30-m cff text-center dmargin-top-20 mmargin-bottom-28">{{content.description}}</div>
            <div class="m-auto margin-top-10 search-component-bar dmargin-top-20 pointer mw740 tmw540" @click="searchPopup()">
              <div class="white f14-l17 df20-l20 pointer search-button" @click.stop="performSearch()">
                {{content.form.submit.label}}
                <img src="@/assets/home-search-right-arrow.svg">
              </div>
              <div class="f14-l30 df20-l20 position-absolute cityinput">
                <SvgImage :src="content.form.fields[0].icon" />
                {{content.form.fields[0].text}}
                <FormHiddenFieldComponent type="hidden" :name="content.form.fields[0].data_name" :value="''+content.form.fields[0].val" />
              </div>
              <div class="f14-l30 df20-l20 position-absolute dateinput">
                <SvgImage :src="content.form.fields[1].icon" />
                {{content.form.fields[1].text}}
                <FormHiddenFieldComponent type="hidden" :name="content.form.fields[1].data_name" :value="''+content.form.fields[1].val" />
              </div>
            </div>
            <div class="margin-top-20" style="margin-bottom:30px;" > <!-- -->
              <div v-if="content.login_register" class="text-center f16-l21 cff pointer df20-l20" @click="openLogin(content.login_register[0].button.url)">
                {{content.login_register[0].text}} <span class="f16-l21-sb bold ">{{content.login_register[0].button.label}}</span>
              </div>
              <div class="text-center f16-l21-sb df22-l22-b cff margin-top-10 pointer" @click="openWizard(wizard.data_layer)">{{wizard.title}}</div>
              <div class="text-center f16-l21-sb df22-l22-b cff " style="margin-top: 40px;" v-if="content.special && (this.$isDesktop() || this.$isTablet())" v-html="content.special"></div>
              <div class="text-center f16-l21-sb df22-l22-b cff " style="margin-top: 40px;" v-if="content.donation_link && (this.$isDesktop() || this.$isTablet())" v-html="content.donation_link"></div>
            </div>
          </div>

        </div>
        

      </div>
      <div class="text-center f16-l21-sb df22-l22-b" style="margin-top: 20px;" v-if="content.special && this.$isMobile()" v-html="content.special"></div>
      <div class="text-center f16-l21-sb df22-l22-b" style="margin-top: 20px;" v-if="content.donation_link && this.$isMobile()" v-html="content.donation_link"></div>
    </form>
    <PopupComponent :showClose="false" v-if="showPopup" @close="closePopup">
      <SearchPopupComponent @close="closePopup" />
    </PopupComponent>
    <PopupComponent :showClose="false" v-if="showWizard" @close="closeWizard()">
      <WizardPopupComponent :wizard="wizard" />
    </PopupComponent>
  </div>
</template>
<script>
import {formSubmit} from '@/modules/configuration.js'
import FormHiddenFieldComponent from "@/components/form/FormHiddenFieldComponent"
import SvgImage from "@/components/generic/SvgImage"
import SectionImageComponent from "@/components/generic/SectionImageComponent.vue";
import PopupComponent from '@/components/PopupComponent.vue'
import SearchPopupComponent from '@/components/popup/SearchPopupComponent.vue'
import WizardPopupComponent from "@/components/search/WizardPopupComponent"
import {addGoogleAnalyticsDataLayer} from '@/modules/configuration.js';
export default {
  components: {
    FormHiddenFieldComponent,
    SvgImage,
    SectionImageComponent,
    PopupComponent,
    SearchPopupComponent,
    WizardPopupComponent,
  },
  props: {
    content: Object,
    wizard: Object,
  },
  data() {
    return {
      showPopup: false,
      showWizard: false,
      activeStep: 0,
    }
  },
  methods: {
    searchPopup() {
      this.showPopup = true;
    },
    performSearch() {
      this.showPopup = false;
      let form = this.$refs.formSearch;
      formSubmit(this, form);
    },
    closePopup(refresh) {
      this.showPopup = false;
      if (refresh) {
        this.$router.go(0);
      }
    },
    openWizard(data_layer) {
      // this.activeStep = 0;
      addGoogleAnalyticsDataLayer(data_layer);
      this.showWizard = true;
    },
    closeWizard() {
      this.showWizard = false;
      // this.activeStep = 0;
    },
    // wizardSkip(s) {
    //   this.activeStep += s;
    // },
    // onSubmit() {
    //   let form = this.$refs.form;
    //   formSubmit(this, form);
    // },
    openLogin(url) {
      this.$router.push(url);
    }
  }
}
</script>
<style >
.search-button {
  position: absolute;
  left: 2px;
  top: 2px;
  padding-top: 4px;
  display: inline-block;
  background-color: #ef3d49;
  border-radius: 20px;
  font-size: 20px;
  width: 60px;
  height: 44px;
  text-align: center;
  line-height: 36px !important;
}

.search-component-bar {
  margin-right: 20px;
  margin-left: 20px;
  border-radius: 25px;
  background-color: #ffffff;
  border: 1px solid #ef3d49;
  height: 50px;
  position: relative;
}

.search-component-content-area {
  position: absolute;
  bottom: 0px;
}


.dateinput {
  right: 160px;
  top: 50%;
  transform: translateY(-50%);
}

.cityinput {
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}

.logo-in-search {
  margin-bottom: 9px;
  padding-left: 20px;
}
a.donation-link {
    color: black !important;
    padding: 0 0;
    text-decoration: underline;
}
@media (min-width: 768px) and (max-width: 1200px) { 
  a.donation-link {
    color: white !important;
    padding: 0 0;
    text-decoration: underline;
  }
}

@media (min-width: 1200px) {
  .dateinput {
    right: 250px;
    top: 50%;
    transform: translateY(-50%);
  }

  .search-button {
    left: 0;
    top: 0;
    padding: 0;
    width: 200px;
    height: 50px;
    border-radius: 25px;
    line-height: 50px !important;
  }

  .search-component-bar {
    width: 603px;
    border: 0;
  }

  .search-component-content-area {
    bottom: 10px;
  }

  .search-right-border {
    border-right: 1px solid #ccc;
  }

  .wizard-section-area {
    margin-left: 0px;
    margin-right: 0px;
  }
  a.donation-link {
    color: white !important;
    padding: 0 0;
    text-decoration: underline;
  }
}
</style>
